import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Mail } from 'assets/images/mail.svg';
import { ReactComponent as Phone } from 'assets/images/phone.svg';
import { ReactComponent as Whatsapp } from 'assets/images/whatsapp.svg';

export const ContactButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 24px 0;
  padding-bottom: 24px; /* avoid margin collapse */
  flex-wrap: wrap;
`;

export const Title = styled.h4`
  display: inline-block;
  width: 100%;
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: -0.1px;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Item = styled.div`
  flex: 1;
  margin-right: 16px;

  &:last-child {
    margin-right: 0;
  }
`;

export const Button = styled.button`
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  border: solid 1px ${ColorPalette.HEX.Cultured4};
  background-color: ${ColorPalette.HEX.White};
  color: ${({ theme }) => theme.primaryBackgroundColor};
  cursor: pointer;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const MailIcon = styled(Mail)`
  width: 22px;
`;

export const WhatsappIcon = styled(Whatsapp)`
  width: 22px;
`;

export const PhoneIcon = styled(Phone)`
  width: 22px;
`;
